import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import actionJson from './roadMaintenanceDocumentList.action.json' with { type: 'json' }
import { roadMaintenanceDocumentObject } from '../roadMaintenanceDocumentObject'

export const roadMaintenanceDocumentExpression = expression(roadMaintenanceDocumentObject.shape)

const roadMaintenanceDocumentListDefinition = defineAction({
  ...actionJson,

  input: z.object({
    filter: roadMaintenanceDocumentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      fileName: 'Nome do arquivo',
      id: 'Identificador',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),

  output: z.object({ items: z.array(roadMaintenanceDocumentObject), count: z.number() }),
})

export default roadMaintenanceDocumentListDefinition
